import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './languages/en.js'
import es from './languages/es.js'
import zh from './languages/zh.js'
import ar from './languages/ar.js'
import pt from './languages/pt.js'
import id from './languages/id.js'

Vue.use(VueI18n);

const messages = {

	'en': en ,
	'es': es ,
	'zh': zh ,
	'ar': ar ,
	'pt': pt ,
	'id': id ,
	'it': {},
	'ge': {},
	'fr': {},
	'gr': {}
};

const i18n = new VueI18n({
	locale: 'en', // set locale
	fallbackLocale: 'en', // set fallback locale
	messages, // set locale messages
});

export default i18n;


// WEBPACK FOOTER //
// ./src/plugins/lang/i18n.js